import React from 'react';
import GeoAutocomplete from '@components/geo-autocomplete';
import * as styles from '../Filter/Filter.scss';
import { paramsDefaults } from '../../constants/uiParams';

const GeoSearch = (props) => {
  const {
    handleSelect,
    handleSuggestionsClear,
    baseUrl,
  } = props;

  return (
    <GeoAutocomplete.WithApi
      classNames={{ wrapper: styles.autosuggest }}
      baseUrl={baseUrl}
      onSelectSuggestion={suggestion => handleSelect(suggestion)}
      onSuggestionsClear={handleSuggestionsClear}
      geoTypes={7}
      suggestionsLimit={10}
      defaultInputValue={paramsDefaults.GeoName}
    />
  );
};

export default GeoSearch;
